$(function () {

    //open and close submenu header
    $('.dropdown-menu a.dropdown-toggle').on('click', function (e) {
        if (!$(this).next().hasClass('show')) {
            $(this).parents('.dropdown-menu').first().find('.show').removeClass("show");
        }
        var $subMenu = $(this).next(".dropdown-menu");
        $subMenu.toggleClass('show');

        $(this).parents('li.nav-item.dropdown.show').on('hidden.bs.dropdown', function (e) {
            $('.dropdown-submenu .show').removeClass("show");
        });
        return false;
    });

    //open and close burger menu header
    $('#burger').click(function () {
        $('#burger').toggleClass('icon-close icon-open');
        $('#header').toggleClass('open-menu-border-header');
        $('#burgerButton').toggleClass('line cross');

        $("#button-check-down").css("display", "none");
    });

    //in mobile change border onclick
    function mediaSizeHeader() {
        if (window.matchMedia("(max-width: 992px)").matches) {
            $('#getConnected').click(function () {
                $('#getConnected').toggleClass('border-none');
                $('#getHelp').toggleClass('border-top');
                $('#getConnected').toggleClass('rotate');


            });

            $('#getHelp').click(function () {
                $('#getHelp').toggleClass('border-none');
                $('#getHelp').toggleClass('rotate');
                $('#aboutUs').toggleClass('border-top');
            });

            $('#aboutUs').click(function () {
                $('#aboutUs').toggleClass('border-none');
                $('#aboutUs').toggleClass('rotate');
                $('#contactUs').toggleClass('border-top');
            });

            $('#support').click(function () {
                $('#support').toggleClass('rotate');
            });
            $('#products').click(function () {
                $('#products').toggleClass('rotate');
            });
            $('#customer').click(function () {
                $('#customer').toggleClass('rotate');
            });
        }
    }

    mediaSizeHeader();
    window.addEventListener("resize", mediaSize, false);

    //toggle footer desktop or mobile
    function mediaSize() {
        if (window.matchMedia("(max-width: 768px)").matches) {
            $("#footer-desktop").addClass("d-none");
            $("#footer-mobile").removeClass("d-none");
        } else {
            $("#footer-desktop").removeClass("d-none");
            $("#footer-mobile").addClass("d-none");
        }
    }

    mediaSize();
    window.addEventListener("resize", mediaSize, false);

    //add style in input search address
    $('#searchStreet').on('input', function () {
        var value = $("#searchStreet").val();
        if (value !== '') {
            $("#searchStreet")
                .css("border-bottom-left-radius", "unset")
                .css("border-bottom-right-radius", "unset")
                .css("border-width", "2px")
                .css("border-style", "solid")
                .css("border-color", "#00a98d")
                .css("border-bottom", "none");
            $("#cleanInputValue")
                .css("display", "inline-block")
        } else {
            $("#searchStreet")
                .css("border-bottom-left-radius", "")
                .css("border-bottom-right-radius", "")
                .css("border-width", "")
                .css("border-style", "")
                .css("border-color", "")
                .css("border-bottom", "");
            $("#cleanInputValue")
                .css("display", "none");
        }
    });

    $("#searchStreet").blur(function () {
        $("#searchStreet")
            .css("border-bottom-left-radius", "")
            .css("border-bottom-right-radius", "")
            .css("border-width", "")
            .css("border-style", "")
            .css("border-color", "")
            .css("border-bottom", "");
    });

    $("#searchStreet").focus(function () {
        var value = $("#searchStreet").val();
        if (value !== '') {
            $("#searchStreet")
                .css("border-bottom-left-radius", "unset")
                .css("border-bottom-right-radius", "unset")
                .css("border-width", "2px")
                .css("border-style", "solid")
                .css("border-color", "#00a98d")
                .css("border-bottom", "none");
        }
    });

    //clean input search address value
    $('#cleanInputValue').click(function () {
        $('#searchStreet').val('');
        $("#cleanInputValue")
            .css("display", "none");
        return false;
    });

    //add style in input search address
    $('#searchCoverage').on('input', function () {
        var value = $("#searchCoverage").val();
        if (value !== '') {
            $("#searchCoverage")
                .css("border-bottom-left-radius", "unset")
                .css("border-bottom-right-radius", "unset")
                .css("border-width", "2px")
                .css("border-style", "solid")
                .css("border-color", "#00a98d")
                .css("border-bottom", "none");
            $("#cleanInputValueCoverage")
                .css("display", "inline-block")
        } else {
            $("#searchCoverage")
                .css("border-bottom-left-radius", "")
                .css("border-bottom-right-radius", "")
                .css("border-width", "")
                .css("border-style", "")
                .css("border-color", "")
                .css("border-bottom", "");
            $("#cleanInputValueCoverage")
                .css("display", "none");
        }
    });

    $("#searchCoverage").blur(function () {
        $("#searchCoverage")
            .css("border-bottom-left-radius", "")
            .css("border-bottom-right-radius", "")
            .css("border-width", "")
            .css("border-style", "")
            .css("border-color", "")
            .css("border-bottom", "");
    });

    $("#searchCoverage").focus(function () {
        var value = $("#searchCoverage").val();
        if (value !== '') {
            $("#searchCoverage")
                .css("border-bottom-left-radius", "unset")
                .css("border-bottom-right-radius", "unset")
                .css("border-width", "2px")
                .css("border-style", "solid")
                .css("border-color", "#00a98d")
                .css("border-bottom", "none");
        }
    });

    //clean input search address value
    $('#cleanInputValueCoverage').click(function () {
        $('#searchCoverage').val('');
        $("#cleanInputValueCoverage")
            .css("display", "none");
    });

    //add style header menu on hover
    $("#supportSub").mouseover(function () {
        $("#support").css("font-weight", "600");
    });
    $("#supportSub").mouseout(function () {
        $("#support").css("font-weight", "400");
    });

    $("#supProducts").mouseover(function () {
        $("#products").css("font-weight", "600");
    });
    $("#supProducts").mouseout(function () {
        $("#products").css("font-weight", "400");
    });

    $("#supCustomer").mouseover(function () {
        $("#customer").css("font-weight", "600");
    });
    $("#supCustomer").mouseout(function () {
        $("#customer").css("font-weight", "400");
    });

    initGoogleAnalyticsVirtualPages();

    $('#dropWrapperOne').click(function () {
        $('.list-1-sub').toggleClass('visible');
        $("#dropWrapperOne").toggleClass("border-none border-bottom");
        $("#dropWrapperTwo").toggleClass(" border-top");
        $("#arrow-1").toggleClass("transform-rotate");
    });

    $('#dropWrapperTwo').click(function () {
        $('.list-2-sub').toggleClass('visible');
        $("#dropWrapperTwo").toggleClass("border-none border-bottom");
        $("#dropWrapperThree").toggleClass(" border-top");
        $("#arrow-2").toggleClass("transform-rotate");
    });

    $('#dropWrapperThree').click(function () {
        $('.list-3-sub').toggleClass('visible');
        $("#dropWrapperThree").toggleClass("border-none border-bottom");
        $("#dropWrapperFour").toggleClass(" border-top");
        $("#arrow-3").toggleClass("transform-rotate");
    });

    $('#dropWrapperFour').click(function () {
        $('.list-4-sub').toggleClass('visible');
        $("#arrow-4").toggleClass("transform-rotate");
    });

    var addressInputElement = $('#searchCoverage');
    addressInputElement.on('focus', function () {
        var pacContainer = $('.pac-container');
        $(addressInputElement.parent()).append(pacContainer);
    })

    var addressInputElementSearch = $('#searchStreet');
    addressInputElementSearch.on('focus', function () {
        var pacContainer = $('.pac-container');
        $(addressInputElementSearch.parent()).append(pacContainer);
    })

    var addressInputElementSearchMap = $('#searchCoverage');
    addressInputElementSearchMap.on('focus', function () {
        var pacContainer = $('.pac-container');
        $(addressInputElementSearchMap.parent()).append(pacContainer);
    })


    checkForIncomingGlobals();
});

$.fn.serializeObject = function () {
    var o = {};
    var a = this.serializeArray();
    $.each(a, function () {
        if (o[this.name]) {
            if (!o[this.name].push) {
                o[this.name] = [o[this.name]];
            }
            o[this.name].push(this.value || '');
        } else {
            o[this.name] = this.value || '';
        }
    });
    return o;
};

function checkForIncomingGlobals() {
    var pId = GetParameterValues("pId");

    if (pId) {
        pId = pId.toLowerCase();

        switch (pId) {
            case "omf":
                sessionStorage["pId"] = "OMF";
                break;
            case "hw":
                sessionStorage["pId"] = "HW";
                break;
            default: break;
        }
    }
}

function initGoogleAnalyticsVirtualPages() {
    var gtagConfigId = 'GTM-5SXJLCJ';
    gtag('config', gtagConfigId, {
        'page_title': 'Vuma Result - Supersonic',
        'page_path': '/vuma-complete-order'
    });
    gtag('config', gtagConfigId, {
        'page_title': 'Prepaid - Vuma Reach Locations - Supersonic',
        'page_path': '/prepaid-vuma-reach-location'
    });
    gtag('config', gtagConfigId, {
        'page_title': 'Fibre - Vuma Reach Locations - Supersonic',
        'page_path': '/fibre-vuma-reach-location'
    });
    gtag('config', gtagConfigId, {
        'page_title': 'Fibre - Vuma Reach Locations - Supersonic',
        'page_path': '/homebroadband-vuma-reach-location'
    });
    gtag('config', gtagConfigId, {
        'page_title': 'Prepaid - Products - Supersonic',
        'page_path': '/prepaid-choose-product'
    });
    gtag('config', gtagConfigId, {
        'page_title': 'Fibre - Products - Supersonic',
        'page_path': '/fibre-choose-product'
    });
    gtag('config', gtagConfigId, {
        'page_title': 'homebroadband - Products - Supersonic',
        'page_path': '/homebroadband-choose-product'
    });
    gtag('config', gtagConfigId, {
        'page_title': 'Prepaid - Product Details - Supersonic',
        'page_path': '/prepaid-product-details'
    });
    gtag('config', gtagConfigId, {
        'page_title': 'Fibre - Product Details - Supersonic',
        'page_path': '/fibre-product-details'
    });
    gtag('config', gtagConfigId, {
        'page_title': 'HomeBroadband - Product Details - Supersonic',
        'page_path': '/homebroadband-product-details'
    });
    gtag('config', gtagConfigId, {
        'page_title': 'Prepaid - Smart Wifi - Supersonic',
        'page_path': '/prepaid-add-on'
    });
    gtag('config', gtagConfigId, {
        'page_title': 'Fibre - Smart Wifi - Supersonic',
        'page_path': '/fibre-add-on'
    });
    gtag('config', gtagConfigId, {
        'page_title': 'HomeBroadband - Smart Wifi - Supersonic',
        'page_path': '/homebroadband-add-on'
    });
    gtag('config', gtagConfigId, {
        'page_title': 'Prepaid - User Details - Supersonic',
        'page_path': '/prepaid-personal-details'
    });
    gtag('config', gtagConfigId, {
        'page_title': 'Fibre - User Details - Supersonic',
        'page_path': '/fibre-personal-details'
    });
    gtag('config', gtagConfigId, {
        'page_title': 'HomeBroadband - User Details - Supersonic',
        'page_path': '/homebroadband-personal-details'
    });
    gtag('config', gtagConfigId, {
        'page_title': 'Prepaid - Confirmation - Supersonic',
        'page_path': '/prepaid-confirmation'
    });
    gtag('config', gtagConfigId, {
        'page_title': 'Fibre - Confirmation - Supersonic',
        'page_path': '/fibre-confirmation'
    });
    gtag('config', gtagConfigId, {
        'page_title': 'Homebroadband - Confirmation - Supersonic',
        'page_path': '/homebroadband-confirmation'
    });
    gtag('config', gtagConfigId, {
        'page_title': 'Prepaid - Thank You - Supersonic',
        'page_path': '/prepaid-thank-you'
    });
    gtag('config', gtagConfigId, {
        'page_title': 'Fibre - Thank You - Supersonic',
        'page_path': '/fibre-thank-you'
    });
    gtag('config', gtagConfigId, {
        'page_title': 'HomeBroadband - Thank You - Supersonic',
        'page_path': '/homebroadband-thank-you'
    });
}

function sendAnalytics(name) {
    console.debug("Send analytics for:" + name);
    gtag('event', 'page_view', { 'send_to': 'GTM-5SXJLCJ', 'page_path': name });
}

function getLongAddress(details) {
    let longAddress = "";
    switch (details.address_propertyType) {
        case "complex": longAddress += details.address_complexNumber + " " + details.address_complexName + "<br/>"; break;
        case "building": longAddress += details.address_buildingNumber + " " + details.address_buildingName + "<br/>"; break;
        case "school": longAddress += details.address_schoolNumber + ", " + details.address_schoolName + "<br/>"; break;
        case "estate": longAddress += details.address_estateNumber + ", " + details.address_estateName + "<br/>"; break;
        case "apartment": longAddress += details.address_apartmentNumber + " " + details.address_apartmentName + "<br/>"; break;
        case "freestanding":
        default: break;
    }
    longAddress += details.userAddressHome.replace(/,/gm, ", ");
    if (details.userSuburb != details.userCity) { longAddress += "<br/>" + details.userSuburb; }
    longAddress += "<br/>" + details.userCity;
    longAddress += "<br/>" + details.userProvince;
    longAddress += "<br/>" + details.userPostalCode;

    return longAddress;
}

function getLongDeliveryAddress(details) {
    let longAddress = "";
    switch (details.delivery_propertyType) {
        case "complex": longAddress += details.delivery_complexNumber + " " + details.delivery_complexName + "<br/>"; break;
        case "building": longAddress += details.delivery_buildingNumber + " " + details.delivery_buildingName + "<br/>"; break;
        case "school": longAddress += details.delivery_schoolNumber + ", " + details.delivery_schoolName + "<br/>"; break;
        case "estate": longAddress += details.delivery_estateNumber + ", " + details.delivery_estateName + "<br/>"; break;
        case "apartment": longAddress += details.delivery_apartmentNumber + " " + details.delivery_apartmentName + "<br/>"; break;
        case "freestanding":
        default: break;
    }
    longAddress += details.deliveryStreetAddress.replace(/,/gm, ", ");
    if (details.deliverySuburb != details.deliveryCity) { longAddress += "<br/>" + details.deliverySuburb; }
    longAddress += "<br/>" + details.deliveryCity;
    longAddress += "<br/>" + details.deliveryProvince;
    longAddress += "<br/>" + details.deliveryPostalCode;

    return longAddress;
}